import { CommonModule } from '@angular/common';
import { AfterViewInit,  ChangeDetectorRef,  Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { SafePipe } from 'src/app/pipes/safe.pipe';
import { Data2Service } from 'src/app/services/data2.service';

@Component({
  selector: 'app-svg-definitions',
  standalone: true,
  templateUrl: './svg-definitions.component.html', 
  encapsulation: ViewEncapsulation.None,
  imports: [CommonModule, SafePipe],
  
})
export class SvgDefinitionsComponent implements OnInit, AfterViewInit {
  loadedState=false;
  @Output() loaded = new EventEmitter<any>();
  /** SVG definitions query. Defaults to the site-wide set; pass a custom
   *  query (e.g. '?ranges=30429-30469&svg_definition_ids=252') to load a
   *  page-specific set. */
  @Input() query = '?ranges=14110-14210&ids=28934,536,568,893,556,28925,540,538,885,28928,557,535,541,573,6970,29624,850,12670,553,28935,580,533,539,586,28930,566,29873,13748,542,576,888,555,13749,578,884,564,561,11520,1108,24943,534,7846,7866,7886&svg_definition_ids=252,249';
   private routerSub?: Subscription;  
   definitions:string="";
  location=""
  constructor(private router:Router, private data2Service:Data2Service, private cdr: ChangeDetectorRef) { 
    
    this.location = router.url.split("#")[0]; //solves an issue with <base='/'> converting relative urls in SVG. e.g. filter=url(/#p100) now becomes filter=url(/portfolios/#p100)
    //console.log("SvgDefinitionsComponent > this.location",this.location)
  }
  ngAfterViewInit(): void {
   this.loadedState=true;
   this.loaded.emit(true);
  }

  ngOnInit(): void {
    this.data2Service.svgsDefinitions(this.query).subscribe((resp:string)=>{
      this.definitions= resp;
      //console.log("SVG Definitions loaded", resp.length);
      this.cdr.detectChanges();
    });

    this.routerSub = this.router.events  
      .pipe(filter(event => event instanceof NavigationEnd))  
      .subscribe((event: NavigationEnd) => {  
        this.location = event.urlAfterRedirects.split('#')[0];  
        //console.log('SvgDefinitionsComponent > this.location', this.location);  
      });  
  }
  ngOnDestroy(): void {  
    this.routerSub?.unsubscribe();  
  }  

}
